import Vue from 'vue'
import Vuex from 'vuex'


import { StateAuth, GettersAuth, MutationsAuth, ActionsAuth } from '@/components/auth/store'
import {  StateMenu, GettersMenu, MutationsMenu, ActionsMenu } from '@/views/storeMenu'
import {  StateCams, GettersCams, MutationCams, ActionCams } from '@/components/scan/store'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    uf: [
      { id: "AC", label: "AC" },
      { id: "AL", label: "AL" },
      { id: "AM", label: "AM" },
      { id: "AP", label: "AP" },
      { id: "BA", label: "BA" },
      { id: "CE", label: "CE" },
      { id: "DF", label: "DF" },
      { id: "ES", label: "ES" },
      { id: "GO", label: "GO" },
      { id: "MA", label: "MA" },
      { id: "MG", label: "MG" },
      { id: "MS", label: "MS" },
      { id: "MT", label: "MT" },
      { id: "PA", label: "PA" },
      { id: "PB", label: "PB" },
      { id: "PR", label: "PR" },
      { id: "PE", label: "PE" },
      { id: "PI", label: "PI" },
      { id: "RJ", label: "RJ" },
      { id: "RN", label: "RN" },
      { id: "RO", label: "RO" },
      { id: "RR", label: "RR" },
      { id: "RS", label: "RS" },
      { id: "SC", label: "SC" },
      { id: "SP", label: "SP" },
      { id: "SE", label: "SE" },
      { id: "TO", label: "TO" },
    ],
    queryParam:'',
    parseMsg:true,
    msgError:'',
    displayMsgErr:false,
    displayLoading:false,
    displayMsgSuccess:false,
    MsgSucces:'',
    checkRoute:false,
    redirect:'',
    btnMsg:'fechar',
    appColorBgDark:'#2d2d2d',
    appColorBg:'#E6E6FA',
    ...StateAuth,
    ...StateMenu,
    ...StateCams,
  },
  getters:{
    getQuery: state => state.queryParam,
    getUf: state => state.uf,
    displayLoading: state => state.displayLoading,
    parseMsg: state => state.parseMsg,
    msgError: state => state.msgError,
    displayMsgErr: state => state.displayMsgErr,
    displayMsgSuccess: state => state.displayMsgSuccess,
    countItemBasket: state => state.itemBasket,
    MsgSucces: state => state.MsgSucces,
    getRedirect: state => state.redirect,
    isCheckRoute: state => state.checkRoute,
    btnMsg: state => state.btnMsg,
    bgContainer: state => {return {"background-color":state.appColorBg}},
    bgContainerDark: state => {return {"background-color":state.appColorBgDark}},
    ...GettersAuth,
    ...GettersMenu,
    ...GettersCams,
  },
  mutations: {
    displayLoading: (state,payload) => state.displayLoading = payload,
    setMsgError: (state,payload) => state.msgError = payload,
    setDisplayMsgErr: (state,payload) => state.displayMsgErr = payload,
    displayMsgSuccess: (state,payload) => state.displayMsgSuccess = payload,
    parseMsg: (state,payload) => state.parseMsg = payload,
    MsgSucces: (state,payload) => state.MsgSucces = payload,
    setQuery: (state,payload) => state.queryParam = payload,
    setRedirect: (state,payload) => state.redirect = payload,
    setCheckRoute: (state,payload) => state.checkRoute = payload,
    btnMsg: (state,payload) => state.btnMsg = payload,
    ...MutationsAuth,
    ...MutationsMenu,
    ...MutationCams,
  },
  actions: {
    displayLoading: (context,payload) => context.commit('displayLoading',payload),
    setMsgError: (context,payload) => context.commit('setMsgError',payload),
    setDisplayMsgErr: (context,payload) => context.commit('setDisplayMsgErr',payload),
    displayMsgSuccess: (context,payload) => context.commit('displayMsgSuccess',payload),
    parseMsg: (context,payload) => context.commit('parseMsg',payload),
    MsgSucces: (context,payload) => context.commit('MsgSucces',payload),
    setQuery: (context,payload) => context.commit('setQuery',payload),
    btnMsg: (context,payload) => context.commit('btnMsg',payload),
    ...ActionsAuth,
    ...ActionsMenu,
    ...ActionCams,
  }
})
